import type { ExperienceLevel } from '../../types/user';

export const ROLE_SUGGESTIONS = [
  'Software Developer',
  'Senior Software Engineer',
  'Frontend Developer',
  'Backend Developer',
  'Full Stack Developer',
  'DevOps Engineer',
  'Data Scientist',
  'Data Engineer',
  'Product Manager',
  'Mobile Developer',
  'QA Engineer',
  'Cloud Architect',
  'Chemist Analyst',
  'Laboratory Specialist',
];

export const SKILL_SUGGESTIONS = [
  'Python',
  'JavaScript',
  'TypeScript',
  'React',
  'Node.js',
  'Java',
  'SQL',
  'AWS',
  'Docker',
  'Kubernetes',
  'Terraform',
  'Django',
  'FastAPI',
  'PostgreSQL',
  'Machine Learning',
  'CI/CD',
  'HPLC',
  'Analytical Chemistry',
];

export const LOCATION_SUGGESTIONS = [
  'South Africa',
  'Cape Town',
  'Johannesburg',
  'Netherlands',
  'Amsterdam',
  'London',
  'Berlin',
  'Remote',
];

export const EXPERIENCE_OPTIONS: {
  value: ExperienceLevel;
  label: string;
  description: string;
}[] = [
  { value: 'internship', label: 'Internship', description: 'Studying or seeking first exposure' },
  { value: 'entry', label: 'Entry level', description: 'Up to 2 years of experience' },
  { value: 'associate', label: 'Associate', description: '2-5 years, working independently' },
  { value: 'mid-senior', label: 'Mid / Senior', description: '5-10 years, leading work' },
  { value: 'director', label: 'Director+', description: 'Leading teams or functions' },
];

export const CURRENCIES = ['ZAR', 'USD', 'EUR', 'GBP'];

export const STEPS = [
  { id: 'roles', title: 'What role are you after?', subtitle: 'We will put these jobs at the top of your feed.' },
  { id: 'skills', title: 'What are you good at?', subtitle: 'Your skills sharpen how we rank every match.' },
  { id: 'location', title: 'Where do you want to work?', subtitle: 'Add the places you would genuinely relocate to or already live.' },
  { id: 'experience', title: 'Where are you in your career?', subtitle: 'This filters out roles that would waste your time.' },
  { id: 'review', title: 'Here is your profile', subtitle: 'You can change any of this later from your settings.' },
  { id: 'plan', title: 'Pick how you want to start', subtitle: 'Free works forever. Paid passes expire on their own, so nothing renews automatically.' },
] as const;
